// extracted by mini-css-extract-plugin
module.exports = {"section1":"_____1_Mobile3_section1___TYD_","section1_sale":"_____1_Mobile3_section1_sale__R5Gsy","btn-start":"_____1_Mobile3_btn-start__76Agk"};